mutation DeleteGiveaway($giveawayId: ID!) {
  result: StreamToolsDeleteGiveaway(giveawayId: $giveawayId) {
    id
    deleted
  }
}
